<template>
<div>
  <div>
    <h3 v-html="title"  class="wc-title"></h3>
  </div>
  <div class="wc-container">
    <div v-for="(item, index) in tabsData" :key="index" v-on:click="tabSelect(item)" class="wc-tabs">
      <span v-html="item.name"></span>
    </div>
    <div class="wc-content-area">
      <div v-if="seletedTab=='bar'">
        <bar-chart :data-api="dataApi" :filters="filters" :api-key="apiKey" :height="height" :width="width" :bar-orientation="barOrientation"></bar-chart>
      </div>
      <div v-else-if="seletedTab=='table'">
        Table Goes Here
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "WrapperComponent",
  props: {
    title: {
      type: String,
      default: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit'
    },
    width: {
      type: Number,
      default: 960,
    },
    height: {
      type: Number,
      default: 400,
    },
    dataApi: {
      //data-api
      type: String,
      default: "https://cors-anywhere.herokuapp.com/https://idd.thinkbluedata.com/api/v1/idd-format-chart-data",
    },
    filters: {
      type: String,
      default: '{ "chart-type": "bar", "data-key": "contrib_to_ttl", "node-type": "data_files", "filters": {"key": "drought" }}'
    },
    apiKey: {
      type: String,
      default: "d75d42be128592c22e9ebfdd9619778b",
    },
    tabs: {
      type: String,
      default: '[{"name":"Bar Chart","key":"bar","param":{"isWrapY":false}}, {"name":"Table View","key":"table","param":{}}]'
    },
    barOrientation: {
      type: String,
      default: "horizontal" // horizontal || horizontal-grouped || vertical || grouped
    },
  },
  // the component's data
  data() {
    return {
      tabsData: null,
      seletedTab: null
    };
  },
  components: {
    BarChart: () => import('../idd-bar-chart/idd-bar-chart.vue'),
  },
  // You can do whatever when the selected node changes
  watch: {
    selectedNode(newData, oldData) {
      console.log("The selected node changed...", newData, oldData);
    },
    filters: function () {
      this.initialize();
    },
  },
  // In the beginning...
  mounted() {
    this.initialize();
  },
  methods: {
    // Called once, to create the hierarchical data representation
    initialize() {
      // let self = this;
      const tabsData = JSON.parse(this.tabs);
      // console.log(tabsData);
      this.tabsData = tabsData;
      this.seletedTab = this.seletedTab ? this.seletedTab : this.tabsData.length > 0 ? this.tabsData[0].key : null;
    },
    tabSelect(item) {
      // console.log("===>", item.name);
      this.seletedTab = item.key;
    }
  },
};
</script>

<style>
.wc-container {
  background: #FFFFFF;
  /* Basic / 600 */

  border: 1px solid #8F9BB3;
  box-sizing: border-box;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  /* identical to box height */
  align-items: center;

  /* Basic / 700 */

  color: #2E3A59;
}

.wc-tabs {
  padding: 10px 28px;
  display: inline-block;
  border-right: 1px solid #8F9BB3;
  border-bottom: 1px solid #8F9BB3;
  cursor: pointer;

}

.wc-tabs:hover {
  background: #ccc
}

.wc-content-area {
  padding: 5px;
}

.wc-title {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 26px;
  line-height: 28px;

  /* Dark grey */

  color: #00AEEF;
  margin-bottom: 48px;
}
</style>
